__turbopack_context__.v({
  "caption": "JadeAISection-module__ADL_4a__caption" + " " + __turbopack_context__.i(515534)["sectionLabel"],
  "card": "JadeAISection-module__ADL_4a__card",
  "cardBodyText": "JadeAISection-module__ADL_4a__cardBodyText" + " " + __turbopack_context__.i(515534)["cardBody"],
  "cardHeading": "JadeAISection-module__ADL_4a__cardHeading" + " " + __turbopack_context__.i(515534)["cardTitle"],
  "cardImageWrapper": "JadeAISection-module__ADL_4a__cardImageWrapper",
  "cardTextBlock": "JadeAISection-module__ADL_4a__cardTextBlock",
  "cardVideo": "JadeAISection-module__ADL_4a__cardVideo",
  "carouselWrapper": "JadeAISection-module__ADL_4a__carouselWrapper",
  "controls": "JadeAISection-module__ADL_4a__controls",
  "dot": "JadeAISection-module__ADL_4a__dot",
  "emblaContainer": "JadeAISection-module__ADL_4a__emblaContainer",
  "emblaSlide": "JadeAISection-module__ADL_4a__emblaSlide",
  "emblaViewport": "JadeAISection-module__ADL_4a__emblaViewport",
  "navButtonWrapper": "JadeAISection-module__ADL_4a__navButtonWrapper",
  "section": "JadeAISection-module__ADL_4a__section",
  "sectionContent": "JadeAISection-module__ADL_4a__sectionContent",
  "sectionDesc": "JadeAISection-module__ADL_4a__sectionDesc",
  "sectionTitle": "JadeAISection-module__ADL_4a__sectionTitle" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "webGLBackground": "JadeAISection-module__ADL_4a__webGLBackground",
});
